export default "__VITE_ASSET__DCq6Qti9__"